import React, { useContext, useEffect, useState, useRef } from "react";
import { useOutletContext, useNavigate } from "react-router";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Loading from "components/Loading";
import api from "utils/axiosInstance";
import { UserContext } from "context/User/UserContext";

const containerStyle = {
  width: "100%",
  maxWidth: "800px",
  aspectRatio: "16 / 9",
  overflow: "hidden",
};

const videoStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  borderRadius: "8px", // optional
};

export function Learning() {
  const { weekNumber, moduleData } = useOutletContext();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { user } = useContext(UserContext);
  const videoRef = useRef(null);

  useEffect(() => {
    (async function () {
      if (moduleData && !moduleData.isLocked) {
        var isQuizComplete = null;
        if (user.username) {
          if (weekNumber >= 2) {
            const quizCompleteStatusRes = await getQuizCompleteStatus(
              user.username,
              weekNumber - 1
            );
            isQuizComplete = quizCompleteStatusRes.data;
            if (!isQuizComplete) navigate(`../${weekNumber - 1}/quiz`);
          }
        } else {
          alert("Unable to get the status of the quiz");
        }
      }
      setLoading(false);
    })();
  }, [weekNumber, moduleData]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.load();
    }
  }, [moduleData]);

  async function getQuizCompleteStatus(subjectId, weekNumber) {
    var quizCompleteStatus = null;
    try {
      quizCompleteStatus = await api({
        url: `/edu/module/${subjectId}/quiz/${weekNumber}/complete`,
        method: "get",
      });
      return quizCompleteStatus;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  if (!moduleData || loading) return <Loading />;

  if (moduleData.isLocked)
    return (
      <Container className="text-center mt-5">
        <h1 className="display-3">Module Locked</h1>
        <p className="lead">
          The module is currently locked. Please complete the previous module
          before starting this module
        </p>
        <Button
          variant="primary"
          onClick={() => navigate(process.env.PUBLIC_URL + "/subject")}
        >
          Go Back
        </Button>
      </Container>
    );

  return (
    <Container className="py-4">
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8} className="mb-4">
          <Card className="shadow-lg">
            <Card.Body className="d-flex justify-content-center">
              <div style={containerStyle}>
                <video
                  ref={videoRef}
                  controls
                  style={videoStyle}
                  controlsList="nodownload"
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <source
                    src={process.env.PUBLIC_URL + `${moduleData.url}`}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col xs={12} sm={6} md={5} lg={4} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body className="text-center">
              <Card.Title>Internet Links</Card.Title>
              {Object.entries(moduleData.videoLinks).map(([key, value]) => (
                <div key={key}>
                  <a href={`${value}`} target="_blank" rel="noreferrer">
                    {`${key}`}
                  </a>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} sm={6} md={5} lg={4} className="mb-3">
          <Card className="h-100 shadow-sm">
            <Card.Body className="text-center">
              <Card.Title>Handouts</Card.Title>
              {Object.entries(moduleData.handoutLinks).map(([key, value]) => (
                <div key={key}>
                  <a
                    href={process.env.PUBLIC_URL + `${value}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {`${key}`}
                  </a>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
